// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","tagLine":"Header_tagLine__1KQ7K","mobile":"Header_mobile__vF5eC"};